// extracted by mini-css-extract-plugin
export default {"button":"LogoutButton_button__bqVof","icon":"LogoutButton_icon__R5PED"};